export default __webpack_public_path__ + "static/media/Group 10939.4d04f777.svg";